module.exports = __webpack_public_path__ + "img/reportes-slick.b04a13e5.svg";